<template>
  <div class="share-links d-flex justify-content-evenly">
    <component :is="componentForChannel(channel)" v-for="channel of channelsToShow" :key="channel.kind"
               :entity-type="entityType" :entity-slug="entitySlug"
               :channel-settings="channel" :utm-medium="utmMedium" />

    <web-share-api-button v-if="webShareSupported" :utm-medium="utmMedium" />
  </div>
</template>

<script>
import BlueskyShareButton from './bluesky-share-button'
import capitalize from 'lodash/capitalize'
import FacebookShareButton from './facebook-share-button'
import MessengerShareButton from './messenger-share-button'
import TwitterShareButton from './twitter-share-button'
import WebShareApiButton from './web-share-api-button'
import webShareSupportedUtil from '@/utils/web-share-supported'
import WhatsappShareButton from './whatsapp-share-button'

export default {
  components: {
    BlueskyShareButton, FacebookShareButton, MessengerShareButton, TwitterShareButton, WebShareApiButton,
    WhatsappShareButton
  },

  props: {
    channels: {
      type: Array,
      required: true
    },

    entitySlug: {
      type: String,
      required: false
    },

    entityType: {
      type: String,
      required: true
    },

    utmMedium: {
      type: String,
      required: false
    }
  },

  computed: {
    channelsToShow() {
      // Do not show Email button
      return this.channels.filter((c) => c.kind !== 'email')
    },

    webShareSupported() {
      return webShareSupportedUtil()
    }
  },

  methods: {
    componentForChannel(channel) {
      return `${capitalize(channel.medium)}ShareButton`
    }
  }
}
</script>
